import React from 'react';

const Error404 = () => {
    return ( 
        <div>
            <h2>Error404</h2>
            <p>La pagina que buscas fue cambiada de lugar o no existe</p>
        </div>
     );
}
 
export default Error404;